<template>
  <div ref="container">
    <div
      v-for="(tags, tagType) in groupedTags" 
      :key="tagType"
      class="timeline__item-container"
    >
      <div class="timeline__item timeline__item--hide-timeline">
        <i class="fa fa-tag m-t-2 f-s-10" />
        
        <div>
          <div class="m-l-7 m-b-3">
            <strong>{{ tagType | camelCaseFormat }}</strong>
          </div>
            
          <div>
            <div
              v-for="(tag, index) in tags"
              :key="index"
              class="generic-args"
            >
              <span
                class="generic-args__name overflow-ellipsis"
              >
                <TruncatedTextCopy 
                  :title="tag.name"
                  :copy-text="tag.name"
                  placement="top"
                >
                  <span>
                    {{ tag.name | camelCaseFormat }}
                  </span>
                </TruncatedTextCopy>
              </span>

              <span
                class="generic-args__value"
              >
                <TruncatedTextCopy 
                  title="Click to filter"
                  :copy-text="tag.value"
                  placement="top"
                >
                  <span
                    class="filterable-cell" 
                    @click="addTagFilter(tag)"
                  >
                    {{ tag.value }}
                  </span>

                  <template
                    v-if="tagActionsAvailable"
                    #extras
                  >
                    <a
                      v-tooltip.top="'Add Tag as Column'"
                      class="btn btn-link m-l-2 m-t-2 p-0 no_border truncated-text-copy__icon"
                      @click="$emit('addTagAsColumn', tag)"
                    >
                      <i class="fa fa-columns" />
                    </a>

                    <a
                      v-tooltip.top="'Click to filter'"
                      class="btn btn-link m-l-2 m-t-2 p-0 no_border truncated-text-copy__icon"
                      @click="addTagFilter(tag)"
                    >
                      <i class="fa fa-filter" />
                    </a>
                  </template>
                </TruncatedTextCopy>

              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TruncatedTextCopy from '@/angularBridgeCode/components/TruncatedTextCopy';
import callLogDetailMixin from '../mixins/callLogDetailMixin';

export default {
  name: 'TagsCallLogDetail',
  components: {
    TruncatedTextCopy,
  },
  mixins: [callLogDetailMixin],

  props: {
    groupedTags: {
      type: Object,
      default() {
        return {};
      }
    },
    tagActionsAvailable: {
      type: Boolean,
      default() {
        return true;
      }
    },
  },
  methods: {
    addTagFilter(tag) {
      const tagId = `${tag.type}:${tag.name}`;
      this.addFilter(
        'tag:' + tagId,
        tag.value,
        '',
        tag.type,
        true,
        { tagType: tag.type, tagName: tag.name, tagSource: tag.source }
      );
    },
  }
};
</script>

<style lang="scss" scoped>

</style>